export const SpeechSDK = window.SpeechSDK;
export const Audio24Khz48KBitRateMonoMp3 = 6;
export const CANCELED = 1;
